import { KeyValuePair, PicSearchData, PicSearchMode, PicTypeRuleAirtable } from '@typings';
import Airtable from 'airtable';

/**
 * Converts raw Airtable PIC type strings into key-value pairs.
 * Example: "SA-Stock-Agent" -> { key: "SA", value: "Stock-Agent" }
 */
export const convertPicTypeStringsToKeyValuePairs = (picTypeStrings: string[]): KeyValuePair[] => {
    if (!picTypeStrings || picTypeStrings.length === 0) {
        return [];
    }

    return picTypeStrings.map((picTypeString) => {
        const parts = picTypeString.split('-');
        if (parts.length >= 2) {
            return { key: parts[0], value: parts.slice(1).join('-') };
        }
        return { key: picTypeString, value: picTypeString };
    });
};

export const mapRuleRecord = (record: Airtable.Record<any>): PicTypeRuleAirtable | null => {
    const ruleId = record.get('Rule ID') as number;
    if (!ruleId) return null;

    return {
        ruleId,
        message: record.get('Message') as string,
        messageType: record.get('Message Type') as PicTypeRuleAirtable['messageType'],
        ruleEnabledFor: record.get('RuleEnabledFor') as PicSearchMode[],
    };
};

export const mapStateConfigRecord = (
    record: Airtable.Record<any>,
    rulesMap: Map<string, PicTypeRuleAirtable>
): PicSearchData => {
    const rawPicTypes = (record.get('ApplicablePicTypes') as string[]) ?? [];
    const convertedPicTypes: KeyValuePair[] = convertPicTypeStringsToKeyValuePairs(rawPicTypes);

    const rules = ((record.get('Custom Rules') as string[]) ?? [])
        .map((linkedId) => rulesMap.get(linkedId) ?? null)
        .filter((rule): rule is PicTypeRuleAirtable => !!rule);

    return {
        state: record.get('State') as string,
        active: record.get('Active') as boolean,
        priority: record.get('Priority') as number,
        applicablePicTypes: convertedPicTypes,
        rules,
    };
};
